<template>
    <el-dialog :title="title" :visible.sync="visibleSync" :close-on-click-modal="false">
        <el-row>
            <el-col :span="2">属性:</el-col>
            <el-col :span="4"><text-formatter type="select" :options="dic_type" v-model="_item.enum_dic_type"></text-formatter></el-col>
            <el-col :span="2">编码:</el-col>
            <el-col :span="4"
                ><span>{{ item && item.code }}</span></el-col
            >
            <el-col :span="2">名称:</el-col>
            <el-col :span="10"
                ><span>{{ item && item.name }}</span></el-col
            >
        </el-row>
        <el-row>
            <el-col :span="22">{{ title }}:</el-col>
            <el-col :span="2"><el-button type="primary" size="mini" @click="addRow()">创建</el-button></el-col>
        </el-row>
        <el-table :data="datalist">
            <el-table-column type="index" label="序号" width="50" header-align="center"> </el-table-column>
            <el-table-column label="属性" prop="enumDicType" width="180" header-align="center">
                <template slot-scope="scope">
                    <item-input
                        type="select"
                        v-model="scope.row['enumDicType']"
                        :options="filter_dic_type_option(scope.row)"
                        @input="enum_dic_type_change({ index: scope.$index, row: scope.row })"
                    ></item-input>
                </template>
            </el-table-column>
            <el-table-column label="名称" prop="id" width="400" header-align="center">
                <template slot-scope="scope">
                    <item-input type="remoteselect" v-model="scope.row['id']" :options="filter_id_option(scope.row)" @input="id_change({ index: scope.$index, row: scope.row })"></item-input>
                </template>
            </el-table-column>
            <el-table-column label="ICD编码" prop="code" width="100" header-align="center"> </el-table-column>
            <el-table-column label="操作" header-align="center">
                <template slot-scope="scope">
                    <span style="color: red; font-size: 20px" class="cus-button">
                        <span @click="removeRow(scope.$index, scope.row)" class="el-icon-delete"></span>
                    </span>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button @click="visibleSync = false">取 消</el-button>
            <el-button type="primary" @click="Confirm">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: `Relation`,
    props: {
        title: { type: String },
        visible: { type: Boolean },
        item: {
            type: Object,
            default: () => {
                return { name: `--`, code: `--`, enum_dic_type: 1 }
            }
        },
        area: { type: String }
    },
    data() {
        return {
            datalist: [],
            buttons: [
                {
                    label: `删除`,
                    icon: `el-icon-delete`,
                    type: `primary`,
                    emit: `removeRow`,
                    permission: `default`
                }
            ],
            dic_type: [
                { value: 1, label: `院内版` },
                { value: 2, label: `非标准` },
                { value: 3, label: `互联互通` },
                { value: 4, label: `上传` },
                { value: 5, label: `国标` }
            ]
        }
    },
    computed: {
        _item() {
            this.datalist =
                (_.isArray(this.item.relations) &&
                    this.item.relations.map(r => {
                        let { id, code, enumDicType, name } = r
                        enumDicType = r.enum_dic_type
                        let t = _.find(this.dic_type, { value: enumDicType })
                        return { id: { value: id, label: name }, code, enumDicType, dic_type_option: [{ ...t }], id_option: [{ value: id, label: name }] }
                    })) ||
                []
            return this.item
        },
        url() {
            return {
                get: `/api/AcisSystem/${this.area}/Get`,
                put: `/api/AcisSystem/${this.area}/SetRelations`,
                search: `/api/AcisSystem/${this.area}/Search`
            }
        },
        visibleSync: {
            get: function() {
                return this.visible
            },
            set: function(newval) {
                this.datalist = [] // 清除
                this.$emit(`update:visible`, newval)
            }
        }
    },
    created() {
        this.datalist = []
    },
    methods: {
        Confirm() {
            let that = this
            that.myaxios
                .put(
                    `${this.url.put}/${that._item.id}`,
                    that.datalist.map(d => d.id.value || d.id)
                )
                .then(data => {
                    this.datalist = [] // 清除
                    that.visibleSync = false
                    that.$emit(`after-relation`, ``)
                })
        },
        removeRow(index, row) {
            this.datalist.splice(index, 1)
        },
        addRow() {
            let t = this._item.enum_dic_type
            let r = []
            let l = this.datalist.length
            if (l > 0 && !this.datalist[l - 1].enumDicType) return
            if (t === 1) {
                let sc = _.filter(this.datalist, { enumDicType: 4 })
                let hlht = _.filter(this.datalist, { enumDicType: 3 })
                let gb = _.filter(this.datalist, { enumDicType: 5 })
                r = [{ value: 2, label: `非标准` }]
                if (sc.length == 0) {
                    // 最多一个上传
                    r.push({ value: 4, label: `上传` })
                }
                if (hlht.length == 0) {
                    // 最多一个互联互通
                    r.push({ value: 3, label: `互联互通` })
                }
                if (gb.length == 0) {
                    // 最多一个国标
                    r.push({ value: 5, label: `国标` })
                }
                this.datalist.push({ index: _.now(), dic_type_option: r, id_option: [] })
            } else if (t === 2) {
                // 最多一个院内诊断
                let yn = _.filter(this.datalist, { enumDicType: 1 })
                if (yn.length < 1) {
                    r = [{ value: 1, label: `院内版` }]
                    this.datalist.push({ index: _.now(), enumDicType: 1, dic_type_option: r, id_option: [] })
                }
            } else if (t >= 3 && t <= 5) {
                r = [{ value: 1, label: `院内版` }]
                this.datalist.push({ index: _.now(), enumDicType: 1, dic_type_option: r, id_option: [] })
            }
        },
        enum_dic_type_change({ index, row }) {
            let that = this
            that.$delete(row, `id`)
            that.$delete(row, `code`)
        },
        id_change({ index, row }) {
            this.myaxios.get(this.url.get, { id: row.id.value }).then(data => {
                this.$set(row, `code`, data.code)
                this.$set(row, `enumDicType`, data.enum_dic_type)
            })
        },
        filter_id_option(row) {
            // if(row.id_option.length>0) return row.id_option
            if (row.enumDicType) {
                return `${this.url.search}?enum_dic_type=${row.enumDicType}`
            } else {
                return `${this.url.search}?enum_dic_type=99`
            }
        },
        filter_dic_type_option(row) {
            if (row.enumDicType) {
                return _.filter(row.dic_type_option, { value: row.enumDicType })
            } else {
                return row.dic_type_option
            }
        }
    }
}
</script>
<style scoped lang="less">
.el-row {
    text-align: left;
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Relation.vue